import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoginService } from '../services/api/login/login.service';
import { UsuarioService } from '../services/api/usuario/usuario.service';
import { APP_ROUTES } from '../constants/routes/app-routes.const';

@Injectable({
    providedIn: 'root'
})
export class UserUpdatedGuard implements CanActivate {

    constructor(
        private loginService: LoginService,
        private userService: UsuarioService,
        private router: Router
    ) {}

    canActivate(): Observable<boolean> {
        const userId = this.userService.getUserId();

        if (!userId) {
            this.router.navigate([APP_ROUTES.ACCOUNT, APP_ROUTES.LOGIN]);
            return of(false);
        }

        return this.loginService.getUpdated(userId).pipe(
            map((data: any) => {
                if (!data.isUpdated) {
                    this.router.navigate([APP_ROUTES.MAIN, APP_ROUTES.PROFILE]);
                    this.userService.setUserIsUpdated('false');
                    return false;
                }
                this.userService.setUserIsUpdated('true');
                return true;
            }),
            catchError(() => {
                this.router.navigate([APP_ROUTES.MAIN, APP_ROUTES.PROFILE]);
                return of(false);
            })
        );
    }
}
